import React, { Component } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress';

class Loading extends Component {
  render() {
    if(!this.props.isLoading && this.props.children) {

      return (this.props.children)
    } else {
      return (
        <div className={this.props.className} style={{ padding: '20px' }}>
          <CircularProgress size={this.props.size} style={{ color: '#0ab23b'}}/>
        </div>
      )
    }
  }
}

export default Loading
